import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
// 使用Element UI
Vue.use(ElementUI)

// 检查token是否有效
const checkToken = () => {
  const token = localStorage.getItem('token')
  if (!token) {
    return false
  }
  // 如果需要更严格的过期验证，可以解析JWT获取过期时间
  // 这里先简单判断token是否存在
  return true
}

router.beforeEach((to, from, next) => {
  // 如果目标路由不是登录页，检查token
  if (to.path !== '/login') {
    if (!checkToken()) {
      // token不存在或已过期，跳转到登录页
      router.push({ name: 'login', query: { relogin: 'true' } })
      return
    }
  }
  next()
})

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
